export default ".invoice-reports-table{width:100%}.invoice-reports-total-row .invoice-reports-total-cell{font-size:larger;font-weight:bolder}";